module.exports = __webpack_public_path__ + "img/avatar-cover.fbedd4ec.png";